<template>
  <div>
    <Head />

    <div class="breadcrumb_box" aria-label="breadcrumb">
      <ol class="breadcrumb container">
        <li class="breadcrumb-item"><router-link to="/">首頁</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">會員註冊</li>
      </ol>
    </div>

    <div class="wrapper sign_up register">
      <section class="main">
        <div class="container">
          <h1>會員註冊</h1>
          <div class="box">
            <p>歡迎來到「餐飲服務業優質成長暨國際推廣計畫」網站，若為首次造訪網站，請先以統編進行帳號註冊，再以此帳號進行報名資料填寫。</p>
            <div class="form-group">
              <label for="">電子信箱</label>
              <!-- <input type="email" class="form-control" id="" aria-describedby="" placeholder="請輸入電子信箱" v-model="Email"
                :disabled="pincodeCheck"> -->
              <input type="text" class="form-control" id="" aria-describedby="" placeholder="請輸入電子信箱" v-model="Email"
                :disabled="pincodeCheck && !RegVerifyDisable">
            </div>
             <!-- <div class="btn_box" v-if="!pincodeCheck">
              <button @click="getPinCode()">{{ pincodeTitle }}</button>
            </div>
            <div class="form-group" v-if="pincode">
              <label for="">驗證碼</label>
              <input type="text" class="form-control" id="" aria-describedby="" placeholder="請輸入驗證碼"
                v-model="pincode_input" @input="pincode_input_onInput" :disabled="pincodeCheck">
            </div>
            <div class="alert alert-info" role="alert" style="margin: 20px 0; padding: 15px; background-color: #e7f3ff; border-left: 4px solid #2196F3; border-radius: 4px;" v-if="pincode && !pincodeCheck">
              <p style="margin: 0 0 8px 0; color: #1976D2; font-weight: 500; text-align: center;">
                如未收到驗證碼請聯繫
              </p>
              <p style="margin: 0 0 5px 0; color: #333; font-weight: 500; text-align: center;">
                <strong>02-2698-2989 #03517</strong> 李小姐
              </p>
              <p style="margin: 0; color: #666; font-size: 0.9em; font-weight: 500; text-align: center;">
                服務時間：週一至週五 09:00～18:00
              </p>
            </div> -->
            <div class="form-group" v-if="pincodeCheck">
              <label for="">統一編號(帳號)</label>
              <input type="text" class="form-control" id="" aria-describedby="" placeholder="請輸入統一編號" v-model="TaxID">
            </div>
            <div class="form-group" v-if="pincodeCheck">
              <label for="">品牌名稱</label>
              <input type="text" class="form-control" id="" aria-describedby="" placeholder="請輸入品牌名稱" v-model="Name">
            </div>
            <div class="form-group" v-if="pincodeCheck">
              <label for="">姓名</label>
              <input type="text" class="form-control" id="" aria-describedby="" placeholder="請輸入姓名" v-model="Nickname">
            </div>
            <div class="form-group" v-if="pincodeCheck">
              <label for="">職稱</label>
              <input type="text" class="form-control" id="" aria-describedby="" placeholder="請輸入職稱" v-model="JobTitle">
            </div>
            <div class="form-group" v-if="pincodeCheck">
              <label for="">電話</label>
              <input type="text" class="form-control" id="" aria-describedby="" placeholder="請輸入電話" v-model="Phone">
            </div>
            <div class="form-group" v-if="pincodeCheck">
              <label for="text">密碼</label>
              <input type="password" class="form-control" id="" aria-describedby="" placeholder="請輸入密碼"
                v-model="Password">
            </div>
            <div class="form-group" v-if="pincodeCheck">
              <label for="">再次輸入密碼</label>
              <input type="password" class="form-control" id="" aria-describedby="" placeholder="請再次輸入密碼"
                v-model="PasswordConfirm">
            </div>
            <div class="btn_box" v-if="pincodeCheck">
              <button @click="sendRegister()">註　　冊</button>
            </div>
          </div>
          <hr>
        </div>
      </section>
    </div>

    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);


import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "Register",
  components: {
    Head,
    Footer,
  },
  data() {
    return {
      Name: "",
      TaxID: "",
      Email: "",
      Password: "",
      PasswordConfirm: "",
      pincode_input: "",
      pincode: "",
      pincodeCheck: false,
      pincodeTitle: "發送驗證碼",
      pincodeTime: 0,
      pincode_Email: "",
      CheckService: false,
      Nickname: "",
      JobTitle: "",
      Phone: "",
      RegVerifyDisable: false,
    };
  },
  watch: {
    //Email(newVal, oldVal) {
    //if (newVal != this.pincode_Email) {
    //    this.pincode = "";
    //    this.pincodeCheck = false;
    //  }
    //},
  },
  beforeCreate: function () {
    if ($cookies.isKey("is_login_token")) {
      this.$router.push({
        name: "Home",
      });
    }
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/GetRegisterSetting",
        {
          params: {
          },
        }
      )
      .then((response) => {
        this.RegVerifyDisable = response.data.RegVerifyDisable;
        if (this.RegVerifyDisable) {
          this.pincodeCheck = true;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    let that = this;
    setTimeout(() => {
      that.badgeStyle = document.createElement('style');
      that.badgeStyle.innerText = '.grecaptcha-badge { display: block !important; visibility: visible !important; opacity: 1 !important; }';
      that.badgeStyle.id = 'show-recaptcha-badge';
      document.head.appendChild(that.badgeStyle);
    }, 500);
  },
  updated: function () {
  },
  methods: {
    pincode_input_onInput() {
      if (this.pincode_input != "" && this.pincode_input == this.pincode) {
        this.pincodeCheck = true;
      } else {
        this.pincodeCheck = false;
      }
    },
    async getPinCode() {
      if (this.pincodeTime > 0) {
        Swal.fire({
          title: "請稍候",
          html: "重新獲取驗證碼需等待 <span>" + this.pincodeTime + "</span> 秒",
          icon: "info",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if (this.Email == "") {
        Swal.fire({
          title: "錯誤",
          text: "請輸入電子信箱",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      } else if (!Validate.reg_email(this.Email)) {
        Swal.fire({
          title: "錯誤",
          text: "電子信箱格式錯誤",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      // 我不是機器人
      let recaptchaToken = await this.getRecaptchaToken();
      if (!recaptchaToken) {
        return;
      }
      // 顯示請稍候
      Swal.fire({
        title: "請稍候...",
        allowOutsideClick: false,
        showConfirmButton: false,
        heightAuto: false,
        willOpen: function () {
          Swal.showLoading();
        },
      });
      // 組合並送出
      let token = AES.encrypt(this.Email + "|" + recaptchaToken);
      let that = this;
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/GetRegPinCode",
        type: "post",
        data: {
          token: token,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            var strInfo = AES.decrypt(res.PinCode).split("|");
            that.pincode = strInfo[0];
            that.pincode_Email = strInfo[1];
            // 倒數
            that.pincodeTime = 60;
            that.pincodeTitle = "重新發送(" + that.pincodeTime + ")";
            var loop = window.setInterval(function () {
              that.pincodeTime -= 1;
              that.pincodeTitle = "重新發送(" + that.pincodeTime + ")";
              if (that.pincodeTime == 0) {
                that.pincodeTitle = "發送驗證碼";
                window.clearInterval(loop);
              }
            }, 1000);
            Swal.fire({
              title: "已發送驗證碼",
              icon: "success",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          } else if (res.error) {
            Swal.fire({
              title: "錯誤",
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          }
        },
      });
    },
    async getRecaptchaToken() {
      try {
        await this.$recaptchaLoaded();
        return await this.$recaptcha('login');
      } catch {
        Swal.fire({
          title: "錯誤",
          text: "請確認網路環境後再試一次（RG）",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return null;
      }
    },
    async sendRegister() {
      if (this.Name == "") {
        Swal.fire({
          title: "錯誤",
          text: "請輸入品牌名稱",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if (this.TaxID == "") {
        Swal.fire({
          title: "錯誤",
          text: "請輸入統一編號",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if (this.Nickname == "") {
        Swal.fire({
          title: "錯誤",
          text: "請輸入姓名",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if (this.JobTitle == "") {
        Swal.fire({
          title: "錯誤",
          text: "請輸入職稱",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if (this.Email == "") {
        Swal.fire({
          title: "錯誤",
          text: "請輸入電子信箱",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      } else if (!Validate.reg_email(this.Email)) {
        Swal.fire({
          title: "錯誤",
          text: "電子信箱格式錯誤",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if (this.Phone == "") {
        Swal.fire({
          title: "錯誤",
          text: "請輸入電話",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      } else if (!Validate.reg_number(this.Phone)) {
        Swal.fire({
          heightAuto: false,
          title: "錯誤",
          text: "電話格式錯誤",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
        });
        return;
      }
      if ((this.Password == "")) {
        Swal.fire({
          title: "錯誤",
          text: "請輸入密碼",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      } else if (this.PasswordConfirm != this.Password) {
        Swal.fire({
          title: "錯誤",
          text: "兩次輸入密碼必須相同",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      // 我不是機器人
      let recaptchaToken = await this.getRecaptchaToken();
      if (!recaptchaToken) {
        return;
      }
      // 顯示請稍候
      Swal.fire({
        title: "請稍候...",
        allowOutsideClick: false,
        showConfirmButton: false,
        heightAuto: false,
        willOpen: function () {
          Swal.showLoading();
        },
      });
      // 開始送出
      let that = this;
      let token = AES.encrypt(
        this.Name +
        "|" +
        this.TaxID +
        "|" +
        this.Email +
        "|" +
        this.Password +
        "|" +
        recaptchaToken +
        "|" +
        this.Nickname +
        "|" +
        this.JobTitle +
        "|" +
        this.Phone
      );
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/Register",
        type: "post",
        data: {
          token: token,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            Swal.fire({
              title: "註冊完成",
              text: "即將返回首頁",
              icon: "success",
              allowOutsideClick: false,
              showConfirmButton: false,
              heightAuto: false,
              timer: 1500,
              willClose: () => {
                that.$router.push({
                  name: "Home",
                });
              },
            });
          } else if (res.error) {
            Swal.fire({
              title: "錯誤",
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          }
        },
      });
    },
  },
};
</script>
